import { Box } from '@material-ui/core'
import { useStyles } from './Styles'
import ExecutionList from './ExecutionList'
import { useExecutions } from '../steps/queries/executions'

export default function Executions(): JSX.Element {
  const styles = useStyles()
  const { pendingExecutions, isLoadingPending, pendingError, refetchPendingExecutions } = useExecutions()
  const { finishedExecutions, isLoadingFinished, finishedError } =
    useExecutions()
  return (
    <Box className={styles.executions}>
      <ExecutionList
        title={'Pending Executions'}
        executions={pendingExecutions}
        refetchPendingExecutions={refetchPendingExecutions}
        withActions
        isLoading={isLoadingPending}
        error={pendingError}
      />
      <ExecutionList
        title={'Past Executions'}
        executions={finishedExecutions}
        isLoading={isLoadingFinished}
        error={finishedError}
      />
    </Box>
  )
}
